import {Component, OnInit, ViewChild} from '@angular/core';
import { GenericModalService } from '../../../services/generic-modal.service';
import { PaginationInstance } from 'ngx-pagination';
import { WebClientConfigurationService } from '../../../services/configuration/web-client-configuration.service';
import {WfTableComponent} from '../../../common/table-sort/wf-table.component';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {DriverService} from '../../../services/configuration/driver.service';
import {FormGroup} from '@angular/forms';
import {MetadataService} from '../../../services/configuration/metadata.service';
import {InstanceDistributionConfigService} from '../../../services/configuration/instanceDistributionConfig.service';

@Component({
  selector: 'app-distribution-custom-interaction',
  templateUrl: './distribution-custom-interaction.component.html',
  styleUrls: ['./distribution-custom-interaction.component.css']
})
export class DistributionCustomInteractionComponent implements OnInit {

  pleaseWait;
  componentForm: FormGroup;
  metadataStructureList: [];
  errorMessage;
  submitted;
  availableMetadata;
  availableOperators=[];
  expressions=[];
  selectedInstanceMetadata;
  selectedOperator;
  selectedQueueMetadata;
  instanceClassification;


  constructor(
    private metadataService: MetadataService,
    private instanceDistributionConfigService: InstanceDistributionConfigService,
    private webClientConfig: WebClientConfigurationService, public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.getAllMetadata();
  }

  getAllMetadata() {
    this.pleaseWait = true;
    this.metadataService.getAllMetadataStructures().subscribe(res => {
      this.availableMetadata = res;
      this.pleaseWait = false;
      this.getInstanceClassification();
    }, error => {
      this.errorMessage = error;
      this.pleaseWait = false;
    });
    this.availableOperators = [];
    this.availableOperators.push({value:'=='});
    this.availableOperators.push({value:'!='});
    this.availableOperators.push({value:'<'});
    this.availableOperators.push({value:'<='});
    this.availableOperators.push({value:'>'});
    this.availableOperators.push({value:'>='});
    this.availableOperators.push({value:'Contains'});
    this.availableOperators.push({value:'!Contains'});
    this.availableOperators.push({value:'In'});
    this.availableOperators.push({value:'!In'});
  }

  getInstanceClassification() {
    this.errorMessage = '';
    this.pleaseWait = true;
    this.instanceDistributionConfigService.getInstanceClassification().subscribe(res => {
      this.instanceClassification = res;
      if (this.instanceClassification.predicateExpression){
        let exp = this.instanceClassification.predicateExpression;
        if (exp.substring(exp.length - 1) == '\n'){
          exp = exp.slice(0, -1)
        }
        this.expressions = exp.split('\n');
      }
      this.pleaseWait = false;
    }, error => {
      this.errorMessage = error;
      this.pleaseWait = false;
    });
  }


  addRule() {
    this.expressions.push(`Instance.Metadata["${this.selectedInstanceMetadata}"] ${this.selectedOperator}  Queue.Metadata["${this.selectedQueueMetadata}"]`);
    this.selectedInstanceMetadata = null;
    this.selectedOperator = null;
    this.selectedQueueMetadata = null;
  }

  removeRule(expr) {
    this.expressions.splice(this.expressions.indexOf(expr), 1);
  }

  onSave() {
    this.pleaseWait = true;
    this.submitted = false;
    this.errorMessage = "";

    if (this.expressions && this.expressions.length > 0){
      this.instanceClassification.predicateExpression = this.expressions.join('\n')+'\n';
    } else {
      this.instanceClassification.predicateExpression = "";
    }
    this.instanceClassification.extensionData= null;
    this.instanceDistributionConfigService.updateInstanceClassification(this.instanceClassification).subscribe(
      () => {
        this.pleaseWait = false;
        this.submitted = true;
        setTimeout(() => {
          this.submitted = false;
        }, 3000);
      }, error => {
        this.pleaseWait = false;
        this.errorMessage = error;
      }
    );
  }

  showSuccessMessage(){
    this.pleaseWait = false;
    this.submitted = true;
    setTimeout(() => {
      this.submitted = false;
    }, 3000);
  }
}
